import { Descriptions } from "@/components/v2";
import { type DescriptionsProps, Popconfirm, Space } from "antd";
import { Link } from "react-router-dom";
import { Rule } from "@rumble-it/common-lib/types/models/Rule.interface";
import { UseMutationResult } from "@tanstack/react-query";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Button, Card } from "@rumbledirect/ui";

interface RuleDetailCardProps {
  rule: Rule | undefined;
  isLoading?: boolean;
  deleteMutation?: UseMutationResult<null, Error, void, unknown>;
}

export const RuleDetailCard = ({
  rule,
  isLoading,
  deleteMutation,
}: RuleDetailCardProps) => {
  const items: DescriptionsProps["items"] = [
    {
      label: "Naam",
      children: rule?.name ?? null,
    },
    {
      label: "Beschrijving",
      children: rule?.description ?? null,
    },
    {
      label: "Event",
      children: rule?.eventName ?? null,
    },
    {
      label: "Voorwaarde matcher",
      children:
        rule?.conditionMatcher == "all"
          ? "Alle condities"
          : "Een van de condities",
    },
    {
      label: "Actief",
      children: rule?.active ? "Ja" : "Nee",
    },
    {
      label: "Prioriteit",
      children: rule?.priority ?? null,
    },
    {
      label: "Stop propagatie",
      children: rule?.stopPropagation ? "Ja" : "Nee",
    },
  ];

  return (
    <Card
      loading={isLoading}
      className="w-full"
      title="Regel"
      extra={
        <Space>
          <Link to={`/rules/${rule?.id}/edit`}>
            <Button icon={<EditOutlined />} />
          </Link>
          <Popconfirm
            title="Regel verwijderen"
            description="Weet je zeker dat je deze regel wilt verwijderen?"
            onConfirm={() => deleteMutation?.mutate()}
            okText="Ja"
            cancelText="Nee"
          >
            <Button
              loading={deleteMutation?.isPending}
              danger
              icon={<DeleteOutlined />}
            />
          </Popconfirm>
        </Space>
      }
    >
      <Descriptions items={items} />
    </Card>
  );
};
